import {
  apiPatch, apiPost,
} from '~/_shared/utils/api/api.helpers';
import { notNullsy } from '~/_shared/utils/typeGuards';
import { type PasswordErrorType } from './passwordErrorType';

export type PasswordResetResponse = {
  message: PasswordErrorType | string;
};

export const sendPasswordResetEmailRequest = (email: string): Promise<PasswordResetResponse> => {
  const requestUrl = '/api/auth/reset/password';
  return apiPost(requestUrl, {
    email,
  });
};

export const sendPasswordResetRequest = ({
  email, expires, hash, signature, password, emailChanged, password_confirmation,
}: {
  email: string;
  emailChanged?: number;
  expires: number;
  hash: string;
  password: string;
  password_confirmation: string;
  signature: string;
}): Promise<PasswordResetResponse> => {
  const emailChangedParam = notNullsy(emailChanged) ? `&email_changed=${emailChanged}` : '';
  const requestUrl = `/api/auth/reset/password?email=${encodeURIComponent(email)}&expires=${expires}&hash=${hash}&signature=${signature}${emailChangedParam}`;
  return apiPatch(requestUrl, {
    password,
    password_confirmation,
  });
};
